import type { RealWedding } from '../types/landing'

export const realWeddings: RealWedding[] = [
  {
    tag: 'Magic everywhere',
    couple: 'Jenni & Mitch',
    description:
      'An adventurous couple who put friends, family and fun first when planning their dream day.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e252b6aa-ad68-4111-8483-3711ece4bd71.jpg',
  },
  {
    tag: 'boho & tropical',
    couple: 'Sarah & Sam',
    description:
      'A music-loving duo with vision who threw an unusual, boho bash that hit all the right notes.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/35c3986c-4df5-4c5e-8618-f66fb76ac10b.jpg',
  },
  {
    tag: 'Boho romance',
    couple: 'Camille & Robert',
    description:
      'A nearby couple who spent a full wedding weekend on property with friends and family.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/be1c96c0-c989-4da0-902a-11b0086edfcb.jpg',
  },
]
